/* eslint-disable no-redeclare */
import { z } from 'zod';

export const REDIRECT_TYPE_PARAM = 'redirectType';

export const RedirectType = z.enum([
  'DEFAULT',
  'SKIP_PII',
  'SURVEY_INACTIVITY',
]);

export type RedirectType = z.infer<typeof RedirectType>;
